import { Card } from 'antd';

import { ErrorFallback, type WidgetErrorProps } from '@/shared/ui/ErrorBoundary';
import { LoadingState } from '@/shared/ui/states/LoadingState';

import { useGpuTemperatures } from '@/features/monitoring/model';
import { GpuTempGauge } from '@/features/monitoring/ui/GpuTempGauge';

import { getGpuGaugeHeight } from '@/widgets/monitoring/shared';

import styles from './GpuTempMetric.module.css';

type GpuTempMetricProps = {
  selectedWorker: string;
};

const Content = ({ selectedWorker }: GpuTempMetricProps) => {
  const shouldFetch = !!selectedWorker;
  const { data: gpuTemps, isLoading } = useGpuTemperatures(selectedWorker || '', shouldFetch);

  const chartHeight = getGpuGaugeHeight(gpuTemps?.length || 4);

  if (!selectedWorker) {
    return (
      <Card title="GPU 평균 온도" className={styles.card}>
        <div className={styles.noData}>Worker를 선택해주세요</div>
      </Card>
    );
  }

  return (
    <Card title="GPU 평균 온도" className={styles.card}>
      {isLoading ? (
        <LoadingState message="GPU 온도 로딩 중..." compact />
      ) : (
        <div
          className={styles.gaugeGrid}
          key={selectedWorker}
          style={{
            gridTemplateColumns: `repeat(${Math.min(gpuTemps?.length || 1, 4)}, 1fr)`,
          }}>
          {gpuTemps && gpuTemps.length > 0 ? (
            gpuTemps.map((gpu) => (
              <GpuTempGauge key={`${selectedWorker}-${gpu.gpu}-${gpu.device}`} data={gpu} height={chartHeight} />
            ))
          ) : (
            <div className={styles.noData}>선택한 Worker에 GPU 온도 데이터가 없습니다.</div>
          )}
        </div>
      )}
    </Card>
  );
};

const Error = ({ title, description, ...props }: WidgetErrorProps) => {
  return (
    <Card title="GPU 평균 온도" className={styles.card}>
      <ErrorFallback title={title} description={description} {...props} />
    </Card>
  );
};

export const GpuTempMetric = { Content, Error };
